import { useEffect, useRef } from "react";

type IndeterminateCheckboxProps = {
  indeterminate?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  label?: React.ReactNode;
  className?: string;
  "data-testid"?: string;
};

const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = ({
  indeterminate,
  checked,
  onChange,
  id,
  label,
  className,
  "data-testid": dataTestId,
  ...props
}) => {
  const checkRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!checkRef.current) return;
    checkRef.current.checked = !!checked;
    checkRef.current.indeterminate = !!indeterminate;
  }, [checked, indeterminate]);

  return (
    <div className={`flex items-center gap-2 ${className || ""}`}>
      <input
        ref={checkRef}
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        data-testid={dataTestId}
        {...props}
      />
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  );
};

export default IndeterminateCheckbox;
